import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IMasrafList_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IMasrafList_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  GetInvoiceExpence: any[];
  GetInvoiceExpence_dummy: any[];
  GetInvoiceExpenceChar: any[];
  GetInvoiceExpenceChar_dummy: any[];
  GetInvoiceExpenceTotal: any[];
  GetInvoiceExpenceTotal_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
}

export class MasrafList_ScreenBase extends React.PureComponent<
  IMasrafList_ScreenProps,
  any
> {
  masraflist_167155_value_kuikaSelectBoxRef: React.RefObject<any>;
  masraflist_222385_value_kuikaTableRef: React.RefObject<any>;
  masraflist_49969_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "4910a89f-68e1-460f-ade3-e7f5918a4340",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 558556, PropertyName: "label", Value: "Profil" },
        { Id: 866762, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 716179, PropertyName: "value", Value: "Masraflar" },
        { Id: 588216, PropertyName: "value", Value: "Masraflar" },
        { Id: 834055, PropertyName: "value", Value: "Toplam Tutar" },
        { Id: 151924, PropertyName: "value", Value: "Toplam Miktar" },
        { Id: 167155, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 542451, PropertyName: "placeholder", Value: "Açıklama..." },
        { Id: 31976, PropertyName: "label", Value: "Ara" },
        { Id: 950435, PropertyName: "label", Value: "Temizle" },
        {
          Id: 222385,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 627176, PropertyName: "title", Value: "Title" },
        { Id: 593319, PropertyName: "value", Value: "Kod" },
        { Id: 480138, PropertyName: "value", Value: "[datafield:itemcode]" },
        { Id: 389949, PropertyName: "value", Value: "Açıklama" },
        {
          Id: 523286,
          PropertyName: "value",
          Value: "[datafield:itemdescription]",
        },
        { Id: 487479, PropertyName: "value", Value: "Miktar" },
        { Id: 707390, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 337214, PropertyName: "value", Value: "Tutar" },
        {
          Id: 988465,
          PropertyName: "value",
          Value: "[datafield:loc_netamount]",
        },
        { Id: 446476, PropertyName: "value", Value: "Tarih" },
        { Id: 953263, PropertyName: "value", Value: "[datafield:invoicedate]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.masraflist_167155_value_kuikaSelectBoxRef = React.createRef();
    this.masraflist_542451_value_kuikaTextInputRef = React.createRef();
    this.masraflist_222385_value_kuikaTableRef = React.createRef();
    this.masraflist_49969_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      GetInvoiceExpence: [],
      GetInvoiceExpenceChar: [],
      GetInvoiceExpenceTotal: [],
      GetImage: [],
      SetValueOf: "",
      dataSource_167155: [
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son 6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("masraflist", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.MasrafListPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("masraflist", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("masraflist", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.MasrafListPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      masraflist_946614_value: this.state.GetImage?.at?.(0)?.photo ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  MasrafListPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      itemDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(3, "number"),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafList/MasrafListPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceExpence = result?.data.getInvoiceExpence;

    stateVars.GetInvoiceExpenceChar = result?.data.getInvoiceExpenceChar;

    stateVars.GetInvoiceExpenceTotal = result?.data.getInvoiceExpenceTotal;
    formVars.masraflist_416512_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceExpenceTotal !== undefined
        ? stateVars.GetInvoiceExpenceTotal?.length > 0
          ? stateVars.GetInvoiceExpenceTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoiceExpenceTotal?.length > 0
        ? this.state.GetInvoiceExpenceTotal[0].loc_NetAmount
        : null
    );
    formVars.masraflist_400569_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceExpenceTotal !== undefined
        ? stateVars.GetInvoiceExpenceTotal?.length > 0
          ? stateVars.GetInvoiceExpenceTotal[0].qty1
          : null
        : this.state.GetInvoiceExpenceTotal?.length > 0
        ? this.state.GetInvoiceExpenceTotal[0].qty1
        : null
    );
    stateVars.GetImage = result?.data.getImage;
    formVars.masraflist_946614_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafListPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafListPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.masraflist_946614_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    stateVars.dataSource_384710 =
      stateVars.GetInvoiceExpenceChar ?? this.state.GetInvoiceExpenceChar;
    formVars.masraflist_416512_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceExpenceTotal !== undefined
        ? stateVars.GetInvoiceExpenceTotal?.length > 0
          ? stateVars.GetInvoiceExpenceTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoiceExpenceTotal?.length > 0
        ? this.state.GetInvoiceExpenceTotal[0].loc_NetAmount
        : null
    );

    formVars.masraflist_400569_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceExpenceTotal !== undefined
        ? stateVars.GetInvoiceExpenceTotal?.length > 0
          ? stateVars.GetInvoiceExpenceTotal[0].qty1
          : null
        : this.state.GetInvoiceExpenceTotal?.length > 0
        ? this.state.GetInvoiceExpenceTotal[0].qty1
        : null
    );

    stateVars.dataSource_222385 =
      stateVars.GetInvoiceExpence ?? this.state.GetInvoiceExpence;
    formVars.masraflist_49969_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceExpence !== undefined
        ? stateVars.GetInvoiceExpence?.length > 0
          ? stateVars.GetInvoiceExpence[0].totalCount
          : null
        : this.state.GetInvoiceExpence?.length > 0
        ? this.state.GetInvoiceExpence[0].totalCount
        : null
    );
    formVars.masraflist_49969_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceExpence !== undefined
        ? stateVars.GetInvoiceExpence?.length > 0
          ? stateVars.GetInvoiceExpence[0].pageCount
          : null
        : this.state.GetInvoiceExpence?.length > 0
        ? this.state.GetInvoiceExpence[0].pageCount
        : null
    );

    formVars.masraflist_49969_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceExpence !== undefined
        ? stateVars.GetInvoiceExpence?.length > 0
          ? stateVars.GetInvoiceExpence[0].totalCount
          : null
        : this.state.GetInvoiceExpence?.length > 0
        ? this.state.GetInvoiceExpence[0].totalCount
        : null
    );
    formVars.masraflist_49969_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceExpence !== undefined
        ? stateVars.GetInvoiceExpence?.length > 0
          ? stateVars.GetInvoiceExpence[0].pageCount
          : null
        : this.state.GetInvoiceExpence?.length > 0
        ? this.state.GetInvoiceExpence[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  MasrafListComponent_961468_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MasrafList",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "388674",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafListComponent_558556_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MasrafList",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafListComponent_866762_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafListComponent_167155_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      itemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masraflist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "masraflist_167155_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masraflist_49969_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "masraflist_167155_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "masraflist_167155_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafList/MasrafListComponent_167155_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceExpence = result?.data.getInvoiceExpence;

    stateVars.GetInvoiceExpenceChar = result?.data.getInvoiceExpenceChar;

    stateVars.GetInvoiceExpenceTotal = result?.data.getInvoiceExpenceTotal;
    formVars.masraflist_416512_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceExpenceTotal !== undefined
        ? stateVars.GetInvoiceExpenceTotal?.length > 0
          ? stateVars.GetInvoiceExpenceTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoiceExpenceTotal?.length > 0
        ? this.state.GetInvoiceExpenceTotal[0].loc_NetAmount
        : null
    );
    formVars.masraflist_400569_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceExpenceTotal !== undefined
        ? stateVars.GetInvoiceExpenceTotal?.length > 0
          ? stateVars.GetInvoiceExpenceTotal[0].qty1
          : null
        : this.state.GetInvoiceExpenceTotal?.length > 0
        ? this.state.GetInvoiceExpenceTotal[0].qty1
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafListComponent_167155_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafListComponent_167155_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "masraflist_49969_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_384710 =
      stateVars.GetInvoiceExpenceChar ?? this.state.GetInvoiceExpenceChar;
    formVars.masraflist_416512_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceExpenceTotal !== undefined
        ? stateVars.GetInvoiceExpenceTotal?.length > 0
          ? stateVars.GetInvoiceExpenceTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoiceExpenceTotal?.length > 0
        ? this.state.GetInvoiceExpenceTotal[0].loc_NetAmount
        : null
    );

    formVars.masraflist_400569_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceExpenceTotal !== undefined
        ? stateVars.GetInvoiceExpenceTotal?.length > 0
          ? stateVars.GetInvoiceExpenceTotal[0].qty1
          : null
        : this.state.GetInvoiceExpenceTotal?.length > 0
        ? this.state.GetInvoiceExpenceTotal[0].qty1
        : null
    );

    stateVars.dataSource_222385 =
      stateVars.GetInvoiceExpence ?? this.state.GetInvoiceExpence;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafListComponent_31976_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      itemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masraflist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "masraflist_167155_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masraflist_49969_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafList/MasrafListComponent_31976_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceExpence = result?.data.getInvoiceExpence;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafListComponent_31976_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafListComponent_31976_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_222385 =
      stateVars.GetInvoiceExpence ?? this.state.GetInvoiceExpence;
    formVars.masraflist_49969_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceExpence !== undefined
        ? stateVars.GetInvoiceExpence?.length > 0
          ? stateVars.GetInvoiceExpence[0].totalCount
          : null
        : this.state.GetInvoiceExpence?.length > 0
        ? this.state.GetInvoiceExpence[0].totalCount
        : null
    );
    formVars.masraflist_49969_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceExpence !== undefined
        ? stateVars.GetInvoiceExpence?.length > 0
          ? stateVars.GetInvoiceExpence[0].pageCount
          : null
        : this.state.GetInvoiceExpence?.length > 0
        ? this.state.GetInvoiceExpence[0].pageCount
        : null
    );

    formVars.masraflist_49969_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceExpence !== undefined
        ? stateVars.GetInvoiceExpence?.length > 0
          ? stateVars.GetInvoiceExpence[0].totalCount
          : null
        : this.state.GetInvoiceExpence?.length > 0
        ? this.state.GetInvoiceExpence[0].totalCount
        : null
    );
    formVars.masraflist_49969_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceExpence !== undefined
        ? stateVars.GetInvoiceExpence?.length > 0
          ? stateVars.GetInvoiceExpence[0].pageCount
          : null
        : this.state.GetInvoiceExpence?.length > 0
        ? this.state.GetInvoiceExpence[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafListComponent_950435_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "masraflist_167155_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("3", "string"),
      null,
      "Key"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "masraflist_542451_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "masraflist_49969_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafListComponent_950435_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  MasrafListComponent_950435_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      itemDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafList/MasrafListComponent_950435_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceExpence = result?.data.getInvoiceExpence;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafListComponent_950435_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafListComponent_950435_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_222385 =
      stateVars.GetInvoiceExpence ?? this.state.GetInvoiceExpence;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafListComponent_49969_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      itemDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masraflist_542451_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "masraflist_167155_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masraflist_49969_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafList/MasrafListComponent_49969_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceExpence = result?.data.getInvoiceExpence;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafListComponent_49969_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafListComponent_49969_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_222385 =
      stateVars.GetInvoiceExpence ?? this.state.GetInvoiceExpence;
    formVars.masraflist_49969_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceExpence !== undefined
        ? stateVars.GetInvoiceExpence?.length > 0
          ? stateVars.GetInvoiceExpence[0].totalCount
          : null
        : this.state.GetInvoiceExpence?.length > 0
        ? this.state.GetInvoiceExpence[0].totalCount
        : null
    );
    formVars.masraflist_49969_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceExpence !== undefined
        ? stateVars.GetInvoiceExpence?.length > 0
          ? stateVars.GetInvoiceExpence[0].pageCount
          : null
        : this.state.GetInvoiceExpence?.length > 0
        ? this.state.GetInvoiceExpence[0].pageCount
        : null
    );

    formVars.masraflist_49969_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceExpence !== undefined
        ? stateVars.GetInvoiceExpence?.length > 0
          ? stateVars.GetInvoiceExpence[0].totalCount
          : null
        : this.state.GetInvoiceExpence?.length > 0
        ? this.state.GetInvoiceExpence[0].totalCount
        : null
    );
    formVars.masraflist_49969_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceExpence !== undefined
        ? stateVars.GetInvoiceExpence?.length > 0
          ? stateVars.GetInvoiceExpence[0].pageCount
          : null
        : this.state.GetInvoiceExpence?.length > 0
        ? this.state.GetInvoiceExpence[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [388674] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.MasrafListPageInit();
    }
  }
}
